import React from 'react'
import { useSelector } from 'react-redux'
import { Route } from 'react-router-dom'

import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'

import { ROLES } from '../common/constants/appConstants'
import { PROVIDERS_DETAILS, PROVIDERS_REGISTER } from '../common/constants/routingConstants'
import { hasRole } from '../common/utils/utils'
import { getAuthRoles } from '../data/auth/authSelectors'
import { SentryRoutes } from '../index'
import ProvidersDashboard from '../providers/dashboard/ProvidersDashboard'
import PaymentsProviderDetails from '../providers/individualProvider/paymentsAdmin/PaymentsProviderDetails'
import ProviderDetails from '../providers/individualProvider/providersAdmin/ProviderDetails'
import RegisterProvider from '../providers/register/RegisterProvider'

const ProvidersRoutes: React.FC = () => {
  const roles = useSelector(getAuthRoles)

  const getDashboard = () => {
    if (hasRole(roles, ROLES.PRACTICES_ADMIN)) {
      return <h1>PROVIDERS_DASHBOARD, for Practice Admin </h1>
    } else if (hasRole(roles, [ROLES.PROVIDERS_ADMIN, ROLES.PAYMENTS_ADMIN])) {
      // @ts-expect-error TS(2739): Type '{}' is missing the following properties from... Remove this comment to see the full error message
      return <ProvidersDashboard />
    } else if (hasRole(roles, ROLES.INDIVIDUAL_PROVIDER)) {
      return <h1>PROVIDERS_DASHBOARD, for Individual Provider </h1>
    } else {
      return <h1>PROVIDERS_DASHBOARD, default</h1>
    }
  }

  const getDetails = () => {
    if (hasRole(roles, ROLES.PROVIDERS_ADMIN)) {
      return <ProviderDetails />
    } else if (hasRole(roles, ROLES.PAYMENTS_ADMIN)) {
      return <PaymentsProviderDetails />
    } else {
      return <h1>PROVIDER_DETAILS, default</h1>
    }
  }

  return (
    <div>
      <ContentLayout>
        <div style={{ marginTop: '50px' }}>
          <SentryRoutes>
            <Route path='/' element={getDashboard()} />
            <Route path={`${PROVIDERS_DETAILS.subroute}/*`} element={getDetails()} />
            <Route path={PROVIDERS_REGISTER.subroute} element={<RegisterProvider />} />
          </SentryRoutes>
        </div>
      </ContentLayout>
    </div>
  )
}

export default ProvidersRoutes
